export default __webpack_public_path__ + "static/media/logo.be3bbe01.svg";